/* eslint-disable import/first */
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import Hreflang from '../../components/Hreflang';
import ClassNames from 'classnames';
import { BiSearch } from '@react-icons/all-files/bi/BiSearch';
import {
  Tabs,
  Tab,
  InputBase,
  IconButton,
  Divider,
  Select,
  MenuItem,
  Button,
} from '@material-ui/core';
import { FaArrowLeft } from '@react-icons/all-files/fa/FaArrowLeft';
import { FaSearch } from '@react-icons/all-files/fa/FaSearch';
import Loader from '../../components/Loader';
const { selectDesktop } = Slices.appSlice;
import TabsContainer from './TabsContainer';
import { generateCategoryRoute } from 'spwa-ui-library/esm/utils/path';
import CartBar from '../../components/CartBar';
import ProductTileList from '../../components/ProductTileList';
import CategoryMenuButton from '../../components/CategoryMenuButton';
const { favouriteCount } = Slices.favouriteSlice;
import MiniCart from '../../components/MiniCart';
import Header from '../../components/Header';
import LanguageButton from '../../components/LanguageButton';
import { FormattedMessage, useIntl } from 'react-intl';
import css from './index.module.scss';
import { categoryNavigationGA, productSearchGA } from 'spwa-ui-library/esm/utils/helperGA';
import SeoTitle from './../../components/SeoTitle/index';
import { AiOutlineCloseCircle } from '@react-icons/all-files/ai/AiOutlineCloseCircle';
import noImg from '../../assets/no-itm.png';
import FavoriteIcon from './images/favorites.png';
import DownArrowIcon from './images/downArrow.svg';
import DefaultSelectionIcon from './images/defaultSelect.svg';
import { debounce } from 'lodash';
import Filter from './Filter';

const { selectDefaultAddress } = Slices.addressSlice;
const {
  selectProductListByCat,
  selectProductEntities,
  fetchProductsByCategoryId,
  clearProductState,
  selectProductFetchStatus,
} = Slices.productSlice;
const { getClusterId } = Slices.configSlice;
const { getPreviouslyOrderedProducts } = Slices.orderSlice;
const { selectLoginStatus } = Slices.authSlice;
const {
  setSelectedCategoryID,
  setCurrentCat,
  selectAllMain,
  fetchCategoryStatus,
  currentCategory,
  selectCategoryById,
  getCategoryProducts,
} = Slices.categorySlice;

import Search from '../Search';

function CategoryWrapper({ encodedCategoryName, categoryID, locale, navigate }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigatePage = useNavigate();
  const location = useLocation();
  const catProducts = useSelector((state) => getCategoryProducts(state, categoryID));
  const categoryState = useSelector((state) => state.category);
  const favourites = useSelector(favouriteCount);
  const cat = useSelector((state) => selectCategoryById(state, categoryID));
  const productsMap = useSelector(selectProductEntities);
  const fav = useSelector((state) => state.favourite);
  const tagsState = useSelector((state) => state.tags);
  const [categoryTags, setCategoryTags] = useState([]);
  const isLoggedIn = useSelector(selectLoginStatus);
  const [selectedCategoryTag, setSelectedCategoryTag] = useState(0);
  const selectedProdListByCat = useSelector(selectProductListByCat);
  const currentCatId = useSelector(currentCategory);
  const address = useSelector(selectDefaultAddress);
  const clusterId = useSelector(getClusterId);
  const categories = useSelector(selectAllMain);
  const [pageLoader, setPageLoader] = useState(false);
  const isDesktop = useSelector(selectDesktop);
  const isLoaded = categoryState.status === 'succeeded';
  const [isDecorated, markDecorated] = useState(false);
  const [decoratedCategories, setCategories] = useState(categories);
  const [index, setIndex] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [openSearch, setOpenSearch] = useState(false);
  const [favCheck] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchState] = useState(false);
  const [swipeableViewsActions] = useState({ updateHeight: () => {} });
  const [usedCategory, setUsedCategory] = useState('');

  const favtCategory = categoryID == 999 ? true : false;

  const itemList = favtCategory ? fav.data.items : catProducts;
  let shouldShowErrorMessage = false;
  let selectedTagItems = itemList?.filter((item) =>
    productsMap[item]?.tags?.some((tag) => selectedCategoryTag === tag)
  );

  if (itemList?.length && selectedCategoryTag && !selectedTagItems?.length) {
    shouldShowErrorMessage = true;
  }

  // TODO: Fix this API call
  // useEffect(() => {
  //   if (categories?.length && !categories?.find((cat) => cat.id == categoryID)?.products?.length) {
  //     dispatch(
  //       fetchProductsByCategoryId({
  //         id: categoryID,
  //         cluster: clusterId,
  //         Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
  //       })
  //     );
  //   }
  // }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (tagsState.status === 'succeeded') {
      const tagsData = Object.values(tagsState?.data || {}).sort(
        (tag1, tag2) => tag1.position - tag2.position
      );
      setCategoryTags(() => tagsData);
    }
  }, [tagsState.data, tagsState.status]);

  useEffect(() => {
    if (isLoggedIn) {
      const payload = {
        isActive: 0,
        page: 1,
      };
      const debouncedDispatch = debounce(dispatch, 2500);
      debouncedDispatch(getPreviouslyOrderedProducts(payload));
      return () => {
        // Cancel the debounced function
        debouncedDispatch.cancel();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // SEARCH PRODUCTS
  const searchProducts = (event) => {
    setSearchKeyword(event.target.value);
    productSearchGA(event.target.value);
  };

  const handleCategoryTagSelection = (tagId) => {
    if (tagId === selectedCategoryTag) {
      setSelectedCategoryTag((prev) => 0);
    } else {
      setSelectedCategoryTag((prev) => tagId);
    }
  };

  // eslint:fix
  React.useEffect(() => {
    if (categoryState.status === 'succeeded' && !categoryState.entities[categoryID]) {
      navigatePage(`/${intl.locale}/home`);
    }
  }, [
    categoryID,
    categoryState.entities,
    categoryState.state,
    categoryState.status,
    index,
    intl.locale,
    navigatePage,
  ]);

  // HANDLE SEARCH METHOD
  const handleSearch = () => {
    setOpenSearch(true);
  };

  // HANDLE PAGE EXIST METHOD
  const handlePageExist = (e) => {
    navigatePage(`/${intl.locale}/home`);
  };
  // const axis = intl.locale === 'ar' ? 'x-reverse' : 'x';
  if (openSearch) {
    return (
      <Search
        TabsContainer={TabsContainer}
        setPageLoader={setPageLoader}
        extraProp={{
          ...{
            decoratedCategories,
            index,
            isDesktop,
            favourites,
            searchProducts,
          },
        }}
        setOpenSearch={setOpenSearch}
      />
    );
  }

  let selectedCategoryInfo = categoryTags.find((category) => category.tagId == selectedCategoryTag);

  let selectedTagInfo = (
    <span className={css.selectedTagFilterItem}>
      <img src={DefaultSelectionIcon} alt={'Select Tag'} />
      <FormattedMessage id="filter_by" defaultMessage={'Filter By'} />
    </span>
  );

  if (selectedCategoryInfo) {
    selectedTagInfo = (
      <span className={css.selectedTagFilterItem}>
        <img src={selectedCategoryInfo.asset.selected} alt={'Select Tag'} />
        {selectedCategoryInfo.categoryName}
      </span>
    );
  }

  const resetFilter = () => {
    setSelectedCategoryTag(0);
  };
  let decoratedCategoryIndex;
  if (decoratedCategories) {
    decoratedCategoryIndex = decoratedCategories.findIndex((cat) => cat.id == categoryID);
  }

  const currentCategoryInfo = decoratedCategories.find(
    (item) => item.name?.toLowerCase()?.replace(/\s+/g, '-') === encodedCategoryName
  );

  return (
    decoratedCategories && (
      <>
        {pageLoader && <Loader />}
        <SeoTitle id="submenu" submenuname={decoratedCategories[decoratedCategoryIndex]?.name} />
        <Hreflang
          categoryPage
          category={(
            currentCategoryInfo?.slug?.toLowerCase() ||
            currentCategoryInfo?.code?.toLowerCase() ||
            currentCategoryInfo?.name?.toLowerCase()
          )?.replace(/\s+/g, '-')}
          categoryId={categoryID}
        />
        <Header
          className={css.whiteBackground}
          icon={<FaArrowLeft onClick={handlePageExist} />}
          title={<FormattedMessage id="explore_menu" defaultMessage={'Explore Menu'} />}
          actionButtons={[<LanguageButton />, <FaSearch onClick={handleSearch} />]}
          desktopActionButtons={[<LanguageButton />]}
          secondaryBar={
            <TabsContainer
              {...{
                decoratedCategories,
                index,
                setCategories,
                isDesktop,
                favourites,
                searchProducts,
                searchState,
                handleSearch,
                categoryTags,
                selectedCategoryTag,
                handleCategoryTagSelection,
                setCategoryTags,
                categoryID,
              }}
            />
          }
        />
        {isDesktop ? (
          <TabsContainer
            {...{
              decoratedCategories,
              index,
              setCategories,
              isDesktop,
              favourites,
              searchProducts,
              searchState,
              handleSearch,
              categoryTags,
              selectedCategoryTag,
              handleCategoryTagSelection,
              setCategoryTags,
              categoryID,
            }}
          />
        ) : (
          ''
        )}
        <div className={css.root}>
          <main className={css.main}>
            {/* TODO: Customize swipeable views for desktop */}
            <div className={ClassNames(isDesktop ? css.desktopWrapper : '')}>
              <div className={css.tabContentContainer}>
                {isDesktop && (
                  <Filter
                    categoryID={categoryID}
                    selectedCategoryTag={selectedCategoryTag}
                    handleCategoryTagSelection={handleCategoryTagSelection}
                    setCategoryTags={setCategoryTags}
                    categoryTags={categoryTags}
                  />
                )}
                {/* {decoratedCategories.map((category, idx) => ( */}
                <div
                  className={ClassNames(css.content, {
                    [css.contentActive]: true,
                    [css.overlayedRoot]: shouldShowErrorMessage,
                  })}
                >
                  {shouldShowErrorMessage && (
                    <div className={css.errorText}>
                      <span>
                        <FormattedMessage id={'no_items_found_filter'} />
                      </span>
                      <span className={css.resetFilterBtn} onClick={resetFilter}>
                        <AiOutlineCloseCircle />
                      </span>
                    </div>
                  )}
                  <div className={css.overlayedElement}>
                    <ProductTileList
                      categoryID={categoryID}
                      setPageLoader={setPageLoader}
                      key={`List-${decoratedCategories[decoratedCategoryIndex]?.name}`}
                      category={decoratedCategories[decoratedCategoryIndex]}
                      selectedCategoryTag={selectedCategoryTag}
                      navigate={navigate}
                      searchKeyword={searchKeyword}
                      setOpenSearch={setOpenSearch}
                      shouldShowErrorMessage={shouldShowErrorMessage}
                    />
                  </div>
                </div>
                {/* ))} */}
              </div>
              {/* </SwipeableViews> */}
              {/* TODO: Add the minicart here */}
              {isDesktop && <MiniCart />}
            </div>
          </main>
          {!isDesktop && <CartBar replaceUrl={true} />}

          <footer className={css.footer}></footer>
        </div>
      </>
    )
  );
}

export default CategoryWrapper;
